const _version = "3.5.0"
function version() {
    return _version
}
export default version
